import Pagination from '@/vuex/modules/pagination'
import PaginationAlternative from '@/vuex/modules/paginationAlternative'
import Usuario from '@/vuex/modules/usuario'
import Captcha from '@/vuex/modules/captcha'
import Combos from '@/vuex/modules/combos'
import Estado from '@/vuex/modules/estado'
import Local from '@/vuex/modules/local'
import Cidade from '@/vuex/modules/cidade'
import Escolaridade from '@/vuex/modules/escolaridade'
import Categorias from '@/vuex/modules/categoria'
import CategoriasRedes from '@/vuex/modules/categoriaRede'
import EstadoCivil from '@/vuex/modules/estadocivil'
import Atuacoes from '@/vuex/modules/atuacao'
import SituacaoSocial from '@/vuex/modules/situacaosocial'
import Dependencias from '@/vuex/modules/dependenciasadministrativas'
import TipoUsuarios from '@/vuex/modules/tipoUsuario'
import Modulo from '@/vuex/modules/modulo'
import Permissao from '@/vuex/modules/permissao'
import TokenEmail from '@/vuex/modules/token'
import Notificacoes from '@/vuex/modules/notificacoes'
import GestanteMae from '@/vuex/modules/gestantemae'
import SemanaGestacao from '@/vuex/modules/semanagestacao'
import Atendimento from '@/vuex/modules/atendimento'
import Conteudo from '@/vuex/modules/conteudo'
import Roda from '@/vuex/modules/roda'
import Pergunta from '@/vuex/modules/pergunta'
import MunicipiosProgramas from '@/vuex/modules/municipiosprogramas'

export default {
  modules: {
    usuario: Usuario,
    captcha: Captcha,
    estado: Estado,
    cidade: Cidade,
    municipiosprogramas: MunicipiosProgramas,
    escolaridade: Escolaridade,
    atuacao: Atuacoes,
    atendimento: Atendimento,
    situacaosocial: SituacaoSocial,
    estadocivil: EstadoCivil,
    tipoUsuarios: TipoUsuarios,
    token: TokenEmail,
    pagination: Pagination,
    paginationAlternative: PaginationAlternative,
    conteudo: Conteudo,
    modulo: Modulo,
    permissao: Permissao,
    dependencias: Dependencias,
    notificacao: Notificacoes,
    gestantemae: GestanteMae,
    semanagestacao: SemanaGestacao,
    categoria: Categorias,
    categoriaRede: CategoriasRedes,
    local: Local,
    combos: Combos,
    roda: Roda,
    pergunta: Pergunta
  }
}



// WEBPACK FOOTER //
// ./src/vuex/store.js